<template>
    <div class="catch-card">
        <div class="catchHeader">
            <p>
                <router-link :to="{ name: 'Catchers', params: { id: catchData.catcher.id } }">
                    <img
                        v-if="catchData.catcher.image"
                        :src="catchData.catcher.image.small"
                        :title="catchData.catcher.image.title"
                    />
                    <span class="img" v-if="!catchData.catcher.image" />
                    <span class="text">{{ catchData.catcher.name }}</span>
                </router-link>
            </p>
            <p>
                <a>
                    <img
                        v-if="catchData.species.image"
                        :src="catchData.species.image.small"
                        :title="catchData.species.image.title"
                    />
                    <span class="img" v-if="!catchData.species.image" />
                    <span class="text">{{ catchData.species.name }}</span>
                </a>
            </p>
            <p>
                <router-link :to="{ name: 'RegionPage', params: { id: catchData.region.id } }">
                    <img
                        v-if="catchData.region.image"
                        :src="catchData.region.image.small"
                        :title="catchData.region.image.title"
                    />
                    <span class="img" v-if="!catchData.region.image" />
                    <span class="text">{{ catchData.region.name }}</span>
                </router-link>
            </p>
        </div>
        <div class="picture">
            <router-link :to="{ name: 'CatchPage', params: { id: catchData.id } }">
                <figure v-if="catchData.image">
                    <img :src="catchData.image.normal" :title="catchData.image.title" />
                </figure>
                <p v-if="!catchData.image">Se detaljer...</p>
            </router-link>
        </div>
        <div class="catchFooter">
            <p class="filler">&nbsp;</p>
            <p>
                <span class="text">{{ getWeight }}</span>
            </p>
            <p>
                <span class="text">{{ parseDate(catchData.date) }}</span>
            </p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CatchCard',
    props: ['catchData'],
    computed: {
        getWeight() {
            return `${this.catchData.weight / 1000} kg`;
        },
    },
    methods: {
        splitRegion: regionPath => regionPath.split('/').filter(part => part !== ''),
        parseDate: dateToParse => new Date(dateToParse).toISOString().slice(0, 10),
    },
};
</script>

<style lang="scss" scoped>
.catch-card {
    background: $backgroundColor;
    margin: 0.2em;
    border: 1px solid $borderColor;
    border-radius: 5px;
    max-width: $maxContentWidth;
    .catchHeader {
        height: 2.2rem;
        top: -0.8rem;
        p {
            padding-right: 1rem;
        }
    }
    .catchFooter {
        bottom: 1.5rem;
        text-align: right;
        p {
            padding-left: 1rem;
        }
    }
    .catchHeader,
    .catchFooter {
        position: relative;
        padding: 0.2rem;
        display: flex;
        flex-direction: row;
        .filler {
            flex: 1;
        }
        a {
            display: flex;
            flex-direction: column;
            text-align: center;
        }
        img,
        .img {
            width: 3rem;
            height: 3rem;
            border-radius: 3rem;
            margin-left: auto;
            margin-right: auto;
            margin-top: 0.8rem;
            opacity: 0.9;
        }
        .text {
            padding: 0.2rem;
            position: relative;
            top: -0.4rem;
            border-radius: 1rem;
            background-color: rgb(240, 240, 240);
            opacity: 0.8;
            font-weight: bold;
            border: 0.1px solid rgb(240, 240, 240);
            &:hover {
                border: 1px solid white;
            }
        }
    }
    a {
        text-decoration: none;
    }
    a:link {
        color: black;
    }
    a:visited {
        color: black;
    }
    a:hover {
        color: navy;
    }
    .picture {
        img {
            width: 100%;
        }
        p {
            border-top: 1px solid $borderColor;
            border-bottom: 1px solid $borderColor;
            padding: 3rem;
        }
    }
}
</style>
